import React, { useMemo } from 'react';
import { Popup } from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import ITpvRapportsXml from "../../models/ITpvRapportsXml";
import { FormListBase, FormListBaseTab, FormListBaseGrid } from '../base';
import { } from 'devextreme-react';
import useCustomDataSource from "../../hooks/useCustomDataSource";

export default function GestionListeResidents() {
  const tpvRapportsFormDataSource = useCustomDataSource<ITpvRapportsXml, ITpvRapportsXml>({ path: "tpvRapportsXml", primaryKey: "idTpvRapportsXml" });
  const { selectedDataRow: selectedTpvRapport, mode,setMode, isFieldModifier, setIsFieldModifier } = tpvRapportsFormDataSource;

  const { fichiersJointsTrouverOptions, fichiersJointsEffacerOptions, msgLeftOptions, msgRightOptions, msgDateOptions, consulterReservationOptions, consulterFactureOptions, imprimerOptions, fermerOptions } = useMemo(() => {
    return {
      fichiersJointsTrouverOptions: { text: "Trouver" },
      fichiersJointsEffacerOptions: { text: "Effacer" },
      msgLeftOptions: { text: "<" },
      msgRightOptions: { text: ">" },
      msgDateOptions: { text: "Mar. 22-04-2012" },
      consulterReservationOptions: { text: "Consulter réservation" },
      consulterFactureOptions: { text: "Consulter facture" },
      imprimerOptions: { text: "Imprimer" },
      fermerOptions: { text: "Fermer" }
    };
  }, []);

  return (
    <Popup
      visible={true}
      // visible={this.state.popupVisible}
      // onHiding={this.hideInfo}
      dragEnabled={true}
      hideOnOutsideClick={true}
      showCloseButton={false}
      showTitle={true}
      title="Liste des résidents"
      container=".dx-viewport"
      width={750}
      height={550}
    >
      <ScrollView width='100%' height='100%'>
        <FormListBase data={tpvRapportsFormDataSource}>
          <FormListBaseTab>
            <TabItem title="Informations">
              <Form>
                <GroupItem colCount={6} alignItemLabels={true}>
                  <SimpleItem key={"frm-idPlanEntete"} editorType={"dxSelectBox"} />
                  <SimpleItem key={"frm-fichiers-joints"} editorOptions={
                    fichiersJointsTrouverOptions
                  } />
                  <SimpleItem key={"frm-fichiers-joints"} editorOptions={
                    fichiersJointsEffacerOptions
                  } />
                  <SimpleItem key={"frm-message-defaut-type"} editorOptions={
                    msgLeftOptions
                  } />
                  <SimpleItem key={"frm-message-defaut-type"} editorOptions={
                    msgDateOptions
                  } />
                  <SimpleItem key={"frm-message-defaut-type"} editorOptions={
                    msgRightOptions
                  } />
                </GroupItem>
                <GroupItem>
                  <DataGrid showBorders={true} allowColumnResizing={true}>
                    <Column caption={"Unité"}>
                    </Column>
                    <Column caption={"Client"}>
                    </Column>
                    <Column caption={"Sexe"} width={40}>
                    </Column>
                    <Column caption={"Date d'arrivé"}>
                    </Column>
                    <Column caption={"Date de départ"}>
                    </Column>
                    <Column caption={"No. Confirmation"}>
                    </Column>
                    <Column caption={"No. Facture"}>
                    </Column>
                  </DataGrid>
                </GroupItem>
                <GroupItem colCount={4}>
                  <SimpleItem key={"frm-message-defaut-type"} editorOptions={
                    consulterReservationOptions
                  } />
                  <SimpleItem key={"frm-message-defaut-type"} editorOptions={
                    consulterFactureOptions
                  } />
                  <SimpleItem key={"frm-message-defaut-type"} editorOptions={
                    imprimerOptions
                  } />
                  <SimpleItem key={"frm-message-defaut-type"} editorOptions={
                    fermerOptions
                  } />
                </GroupItem>
              </Form>
            </TabItem>
          </FormListBaseTab>
        </FormListBase>
      </ScrollView >
    </Popup >
  );
}